<script lang="ts">
  import { fly } from "svelte/transition";
  import { name, selected_game } from "../stores";

  export let GameName: string;
  export let on_create_room: (name: string) => Promise<string>;
  export let on_join_room: (room: string, name: string) => Promise<string>;

  export let player_count: number;

  let room: string;
  let successful_join: boolean = true;

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("r")) {
    const r = urlParams.get("r");
    if (r.length <= 5) {
      room = r;
    }
  }

  clean_url();

  $: create_room = !(room && room.length > 0);
  $: valid_name = $name.length > 0 && successful_join;

  function start() {
    successful_join = false;
    if ($name.length > 0) {
      if (create_room) {
        on_create_room($name).then((r) => {
          room = r;
          add_room();
          successful_join = true;
        });
      } else {
        on_join_room(room, $name).then((r) => {
          room = r;
          add_room();
          successful_join = true;
        });
      }
    }
  }

  function add_room() {
    const new_url = `${window.location.protocol}//${window.location.host}?g=${$selected_game}&r=${room}`;
    window.history.replaceState({ path: new_url }, document.title, new_url);
  }

  function clean_url() {
    const new_url = `${window.location.protocol}//${window.location.host}?g=${$selected_game}`;
    window.history.replaceState({ path: new_url }, document.title, new_url);
  }

  function remove_room() {
    room = null;
    successful_join = true;
    clean_url();
  }
</script>

<div in:fly={{ y: -140, duration: 800 }} class="outter">
  <div class="inner">
    <div class="everything">
      <div>
        <i
          class="fas fa-arrow-left"
          style="font-size: 1.5rem; float: left; margin-left: -2rem; margin-top: 0.4rem; cursor: pointer"
          on:click={() => {
            selected_game.set("None");
          }}
        />

        <h1 class="title">{GameName}</h1>
      </div>
      <div class="form">
        <div class="sec">
          <input
            maxlength="10"
            placeholder="name..."
            spellcheck="false"
            bind:value={$name}
          />
        </div>

        <div class="sec">
          <div class="lower">
            <input
              class={successful_join ? "" : "fail"}
              on:input={() => {
                successful_join = true;
              }}
              maxlength="5"
              size="14"
              placeholder="room..."
              spellcheck="false"
              bind:value={room}
            />
            <button
              class="btn smol"
              on:click={remove_room}
              disabled={!room}
              style="margin-left: 5px"><i class="fas fa-trash" /></button
            >
          </div>
        </div>

        <button class="btn" on:click={start} disabled={!valid_name}
          >{create_room ? "Create" : "Join"} Room</button
        >
      </div>
      <h2 class="footer">
        <i class="fas fa-user" />
        {player_count} active player{player_count == 1 ? "" : "s"}
      </h2>
    </div>
  </div>
</div>

<!-- styling -->
<style>
  .title {
    margin-bottom: 0.3rem;
    user-select: none;
  }

  .fail {
    color: rgb(178, 0, 0);
  }

  .outter {
    height: 100vh;
    display: flex;
    align-content: center;
  }

  .inner {
    text-align: center;
    margin: auto;
  }

  .everything {
    margin-top: -5rem;
  }

  .form {
    text-align: left;
  }

  .sec {
    width: 100%;
  }

  .footer {
    font-size: 0.8rem;
    color: var(--text-color-secondary);
  }

  /* .btn:hover {
    background-color: var(--accent-color-hover);
  }

  .btn:active {
    background-color: var(--accent-color-active);
  } */

  .btn {
    /* width: 100%; */
    width: 100%;
    user-select: none;

    /* background-color: var(--accent-color); */
    outline: none;
    border: none;
    cursor: pointer;
  }

  .smol {
    width: 23%;
  }
  .fa-trash {
    cursor: pointer;
    pointer-events: none;
  }

  .lower {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
</style>
